import { useState, useRef } from 'react';
import { DEFAUTS_PHYSIQUES, GENRES, EDITEURS, ETATS_GENERAUX, STATUTS, LANGUES, FORMATS, LIEUX_ACHAT, SERIES_POPULAIRES } from '../utils/constants';
import { uploadPhoto, deletePhoto, reorderPhotos } from '../utils/firestoreService';
import { useAuth } from '../hooks/useAuth';
import ISBNScanner from './ISBNScanner';

const T = {
  orange:'var(--orange)', orangeD:'var(--orange-d)', yellow:'#F5C842',
  ink:'var(--ink)', bg:'var(--bg)', surface:'var(--surface)',
  border:'var(--border)', borderMd:'var(--border-md)',
  muted:'var(--muted)', subtle:'var(--subtle)', g1:'var(--surface2)',
  green:'#16A34A', red:'#DC2626',
};
const FONT    = "'Inter',-apple-system,BlinkMacSystemFont,sans-serif";
const DISPLAY = "'Bangers','Arial Black',cursive";

const inputStyle = {
  width:'100%', minWidth:0, padding:'10px 13px',
  border:`1.5px solid ${T.border}`, borderRadius:'9px',
  fontFamily:FONT, fontSize:'14px',
  background:T.surface, color:T.ink,
  outline:'none', transition:'border-color .15s, box-shadow .15s',
};
const fo = e => {e.target.style.borderColor=T.orange;e.target.style.boxShadow=`0 0 0 3px rgba(240,78,26,.10)`;};
const bl = e => {e.target.style.borderColor=T.border;e.target.style.boxShadow='none';};

const Label = ({children}) => <div style={{fontSize:'11px',fontWeight:600,color:T.muted,marginBottom:'5px',textTransform:'uppercase',letterSpacing:'.05em',fontFamily:FONT}}>{children}</div>;
const Field = ({label,children,style={}}) => <div style={{marginBottom:'12px',minWidth:0,...style}}><Label>{label}</Label>{children}</div>;
const Grid2 = ({children}) => <div style={{display:'grid',gridTemplateColumns:'minmax(0,1fr) minmax(0,1fr)',gap:'10px'}}>{children}</div>;

const Inp = ({label,f,form,set,type='text',placeholder,...rest}) => (
  <Field label={label}>
    <input style={inputStyle} type={type} value={form[f]||''} placeholder={placeholder}
      onChange={e=>set(p=>({...p,[f]:e.target.value}))} onFocus={fo} onBlur={bl} {...rest}/>
  </Field>
);
const Sel = ({label,f,form,set,opts,empty='— Choisir —'}) => (
  <Field label={label}>
    <select style={{...inputStyle,cursor:'pointer'}} value={form[f]||''} onChange={e=>set(p=>({...p,[f]:e.target.value}))}>
      <option value="">{empty}</option>
      {opts.map(o=>typeof o==='string'?<option key={o} value={o}>{o}</option>:<option key={o.value} value={o.value}>{o.label}</option>)}
    </select>
  </Field>
);

const Sec = ({icon,title}) => (
  <div style={{display:'flex',alignItems:'center',gap:'8px',marginBottom:'14px',paddingBottom:'10px',borderBottom:`1px solid ${T.border}`}}>
    <span style={{fontSize:'16px'}}>{icon}</span>
    <span style={{fontFamily:DISPLAY,fontSize:'1.1rem',letterSpacing:'.05em',color:T.orange}}>{title}</span>
  </div>
);

const empty = () => ({
  serie:'',numero:'',titre:'',auteur:'',dessinateur:'',coloriste:'',scenariste:'',
  editeur:'',collection:'',dateParution:'',isbn:'',format:'',langue:'Français',
  genre:'',nbPages:'',etatGeneral:'bon',defauts:[],statut:'garder',note:0,
  prixAchat:'',prixVente:'',lieu:'',emplacement:'',
  lu:false,dedicace:false,eo:false,numerote:false,
  dateAchat:'',lieuAchat:'',dateLecture:'',
  notes:'',photos:[],
});

/* ── Défauts accordion ──────────────────────────────────── */
function DefautsAccordion({ defauts, onToggle }) {
  const [open, setOpen] = useState(null);
  const entries = Object.entries(DEFAUTS_PHYSIQUES);
  const totalSelected = defauts.length;

  return (
    <div>
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:'8px'}}>
        <Label>Défauts constatés</Label>
        {totalSelected > 0 && (
          <div style={{
            background:'var(--orange-pale)', border:`1px solid #F04E1A33`,
            borderRadius:'99px', padding:'2px 10px',
            fontSize:'11px', fontWeight:700, color:'var(--orange)', fontFamily:FONT,
          }}>
            {totalSelected} sélectionné{totalSelected>1?'s':''}
          </div>
        )}
      </div>

      <div style={{border:`1px solid ${T.border}`,borderRadius:'12px',overflow:'hidden'}}>
        {entries.map(([k, cat], idx) => {
          const catSelected = cat.items.filter(d => defauts.includes(d));
          const isOpen = open === k;
          const isLast = idx === entries.length - 1;

          return (
            <div key={k} style={{borderBottom: isLast ? 'none' : `1px solid ${T.border}`}}>
              {/* En-tête de catégorie */}
              <button
                type="button"
                onClick={() => setOpen(isOpen ? null : k)}
                style={{
                  width:'100%', padding:'12px 14px',
                  background: isOpen ? '#FFF8F5' : T.surface,
                  border:'none', cursor:'pointer', textAlign:'left',
                  display:'flex', alignItems:'center', gap:'10px',
                  fontFamily:FONT, transition:'background .15s',
                }}>
                <span style={{fontSize:'16px',flexShrink:0}}>{cat.icon}</span>
                <span style={{fontSize:'13px',fontWeight:600,color:T.ink,flex:1}}>{cat.label}</span>
                {catSelected.length > 0 && (
                  <div style={{
                    background:'var(--orange)', color:'#fff',
                    borderRadius:'99px', padding:'1px 8px',
                    fontSize:'11px', fontWeight:700, fontFamily:FONT, flexShrink:0,
                  }}>{catSelected.length}</div>
                )}
                <svg
                  width="16" height="16" viewBox="0 0 16 16" fill="none"
                  style={{flexShrink:0,transform:isOpen?'rotate(180deg)':'rotate(0deg)',transition:'transform .2s',color:T.muted}}>
                  <path d="M4 6l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>

              {/* Défauts sélectionnés en aperçu quand fermé */}
              {!isOpen && catSelected.length > 0 && (
                <div style={{padding:'0 14px 10px',display:'flex',flexWrap:'wrap',gap:'4px'}}>
                  {catSelected.map(d => (
                    <div key={d} style={{
                      display:'inline-flex',alignItems:'center',gap:'4px',
                      background:'var(--orange-pale)', border:'1px solid #F04E1A33',
                      borderRadius:'99px', padding:'3px 10px',
                      fontSize:'11px', fontWeight:600, color:'var(--orange)', fontFamily:FONT,
                    }}>
                      <span style={{fontSize:'9px'}}>✓</span>{d}
                      <button
                        type="button"
                        onClick={e=>{e.stopPropagation();onToggle(d);}}
                        style={{background:'none',border:'none',cursor:'pointer',color:'var(--orange)',fontSize:'12px',lineHeight:1,padding:'0 0 0 2px',display:'flex',alignItems:'center'}}>×</button>
                    </div>
                  ))}
                </div>
              )}

              {/* Corps accordéon */}
              {isOpen && (
                <div style={{padding:'4px 12px 14px',background:'#FFF8F5'}}>
                  <div style={{display:'flex',flexWrap:'wrap',gap:'6px'}}>
                    {cat.items.map(d => {
                      const on = defauts.includes(d);
                      return (
                        <button
                          key={d} type="button" onClick={() => onToggle(d)}
                          style={{
                            display:'inline-flex', alignItems:'center', gap:'5px',
                            padding:'7px 12px', borderRadius:'8px', cursor:'pointer',
                            fontFamily:FONT, fontSize:'12px', fontWeight: on ? 600 : 400,
                            border: `1.5px solid ${on ? 'var(--orange)' : T.border}`,
                            background: on ? 'var(--orange-pale)' : T.surface,
                            color: on ? 'var(--orange)' : T.muted,
                            transition:'all .12s', boxShadow: on ? '0 1px 4px rgba(240,78,26,.12)' : 'none',
                          }}
                          onMouseOver={e=>{ if(!on){ e.currentTarget.style.borderColor=T.borderMd; e.currentTarget.style.background=T.g1; }}}
                          onMouseOut={e=>{ if(!on){ e.currentTarget.style.borderColor=T.border; e.currentTarget.style.background=T.surface; }}}>
                          {/* Checkbox visuelle */}
                          <span style={{
                            width:'15px', height:'15px', borderRadius:'4px', flexShrink:0,
                            border:`1.5px solid ${on?'var(--orange)':T.borderMd}`,
                            background: on ? 'var(--orange)' : T.surface,
                            display:'flex', alignItems:'center', justifyContent:'center',
                            transition:'all .12s',
                          }}>
                            {on && <svg width="9" height="7" viewBox="0 0 9 7" fill="none"><path d="M1 3.5L3.5 6 8 1" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/></svg>}
                          </span>
                          {d}
                        </button>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default function BDForm({ bd, onClose, onSave }) {
  const { user } = useAuth();
  const [form, setForm] = useState(bd ? {...empty(),...bd} : empty());
  const [uploading, setUploading] = useState(false);
  const [uploadPct, setUploadPct] = useState(0);
  const [saving, setSaving] = useState(false);
  const [showScanner, setShowScanner] = useState(false);
  const [isbnMsg, setIsbnMsg] = useState('');
  const fileRef = useRef();

  const p = { form, set:setForm };

  // Callback quand ISBN trouvé
  const handleISBNFound = (data, keepOpen = false) => {
    if (!keepOpen) setShowScanner(false);
    // Compter les champs réellement remplis par l'API
    const filled = ['titre','serie','numero','auteur','scenariste','dessinateur',
      'editeur','dateParution','nbPages','genre','langue']
      .filter(k => data[k] && data[k] !== '').length;

    setForm(f => ({
      ...f,
      titre:        data.titre        || f.titre,
      serie:        data.serie        || f.serie,
      numero:       data.numero       || f.numero,
      // Auteur unique OU scénariste/dessinateur si 2 auteurs détectés
      auteur:       data.auteur       || f.auteur,
      scenariste:   data.scenariste   || f.scenariste,
      dessinateur:  data.dessinateur  || f.dessinateur,
      editeur:      data.editeur      || f.editeur,
      dateParution: data.dateParution || f.dateParution,
      nbPages:      data.nbPages      || f.nbPages,
      genre:        data.genre        || f.genre,
      langue:       data.langue       || f.langue,
      isbn:         data.isbn         || f.isbn,
    }));
    const msg = filled > 0
      ? `✓ ${filled} champ${filled>1?'s':''} rempli${filled>1?'s':''} automatiquement`
      : `ISBN ${data.isbn} renseigné — complète les autres champs manuellement`;
    setIsbnMsg(msg);
    setTimeout(() => setIsbnMsg(''), 5000);
  };

  const toggleDef = d => setForm(f=>({...f,defauts:f.defauts.includes(d)?f.defauts.filter(x=>x!==d):[...f.defauts,d]}));

  const handlePhotos = async e => {
    const files = Array.from(e.target.files);
    if (!files.length) return;
    if (!bd?.id) { alert('Sauvegardez d\'abord la BD pour ajouter des photos.'); return; }
    setUploading(true); setUploadPct(0);
    try {
      const photos = [...(form.photos||[])];
      for (let i=0;i<files.length;i++) {
        photos.push(await uploadPhoto(user.uid, bd.id, files[i], (pct) => {
          // Progression réelle : pct de CE fichier + les fichiers déjà uploadés
          const global = Math.round(((i + pct/100) / files.length) * 100);
          setUploadPct(global);
        }));
      }
      setForm(f=>({...f,photos}));
    } catch(e) {
      const msg = e.message || String(e);
      alert(msg);
    }
    setUploading(false); fileRef.current.value='';
  };

  const handleDel = async ph => {
    if (!bd?.id||!window.confirm('Supprimer cette photo ?')) return;
    const remaining = await deletePhoto(user.uid, bd.id, ph.id, ph.url);
    setForm(f=>({...f,photos:remaining}));
  };

  // Déplace la photo à l'index `from` vers l'index `to`, et persiste
  // immédiatement le nouvel ordre (même logique que upload/delete : le doc
  // Firestore est la source de vérité pour l'ordre d'affichage).
  const movePhoto = async (from, to) => {
    if (!bd?.id || to<0 || to>=form.photos.length) return;
    const photos = [...form.photos];
    const [moved] = photos.splice(from,1);
    photos.splice(to,0,moved);
    setForm(f=>({...f,photos})); // MAJ optimiste
    try { await reorderPhotos(user.uid, bd.id, photos); }
    catch(e) { alert('Erreur lors du réordonnancement : '+(e.message||e)); }
  };
  const setCover = i => movePhoto(i, 0);

  const handleSave = async () => {
    if (!form.titre&&!form.serie) { alert('Renseignez au moins un titre ou une série.'); return; }
    setSaving(true);
    try { await onSave(form); }
    catch(e) { setSaving(false); }
  };

  return (
    <>
    <div
      style={{position:'fixed',inset:0,background:'rgba(28,22,18,.6)',display:'flex',alignItems:'flex-end',justifyContent:'center',zIndex:1000,backdropFilter:'blur(6px)',WebkitBackdropFilter:'blur(6px)'}}
      onClick={e=>e.target===e.currentTarget&&onClose()}>
      <div style={{
        background:T.bg, borderRadius:'22px 22px 0 0',
        border:`1px solid ${T.border}`, borderBottom:'none',
        width:'100%', maxWidth:'640px',
        maxHeight:'min(94vh, 94dvh)',
        overflowY:'auto', overflowX:'hidden', fontFamily:FONT,
        boxShadow:'0 -12px 40px rgba(0,0,0,.18)',
        animation:'slideUp .35s cubic-bezier(.22,1,.36,1)',
      }}>

        {/* Header */}
        <div style={{position:'sticky',top:0,zIndex:10,background:'var(--header-bg)',backdropFilter:'blur(10px)',WebkitBackdropFilter:'blur(10px)',borderBottom:`1px solid ${T.border}`,padding:'1rem 1.25rem',display:'flex',alignItems:'center',justifyContent:'space-between',borderRadius:'22px 22px 0 0'}}>
          <div>
            <div style={{fontFamily:DISPLAY,fontSize:'1.35rem',letterSpacing:'.05em',color:T.orange}}>{bd?'Modifier':'Nouvelle BD'}</div>
            {bd?.serie && <div style={{fontSize:'12px',color:T.muted,marginTop:'1px'}}>{bd.serie}{bd.numero?` · T.${bd.numero}`:''}</div>}
          </div>
          <button onClick={onClose} style={{width:'32px',height:'32px',borderRadius:'50%',border:`1px solid ${T.border}`,background:T.surface,cursor:'pointer',fontSize:'16px',color:T.muted,display:'flex',alignItems:'center',justifyContent:'center',boxShadow:'0 1px 3px rgba(0,0,0,.06)'}}>×</button>
        </div>

        {/* Body */}
        <div style={{padding:'1.25rem'}}>

          <div style={{marginBottom:'1.5rem'}}>
            <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:'14px',paddingBottom:'10px',borderBottom:`1px solid ${T.border}`}}>
              <div style={{display:'flex',alignItems:'center',gap:'8px'}}>
                <span style={{fontSize:'16px'}}>📚</span>
                <span style={{fontFamily:"'Bangers','Arial Black',cursive",fontSize:'1.1rem',letterSpacing:'.05em',color:T.orange}}>Identification</span>
              </div>
              <button type="button" onClick={() => setShowScanner(true)}
                style={{
                  display:'flex',alignItems:'center',gap:'6px',
                  padding:'7px 12px',border:`1.5px solid ${T.orange}`,borderRadius:'8px',
                  background:'var(--orange-pale)',color:T.orange,fontFamily:FONT,
                  fontSize:'12px',fontWeight:700,cursor:'pointer',
                  transition:'all .15s',
                }}
                onMouseOver={e=>{e.currentTarget.style.background=T.orange;e.currentTarget.style.color='#fff';}}
                onMouseOut={e=>{e.currentTarget.style.background='var(--orange-pale)';e.currentTarget.style.color=T.orange;}}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/>
                  <rect x="3" y="14" width="7" height="7"/><path d="M14 14h3v3m0 4h4v-4m-7 0h3"/>
                </svg>
                Scanner ISBN
              </button>
            </div>
            {isbnMsg && (
              <div style={{background:'#F0FDF4',border:'1px solid #BBF7D0',borderRadius:'8px',padding:'9px 12px',fontSize:'13px',fontWeight:600,color:'#15803D',marginBottom:'12px',fontFamily:FONT}}>
                {isbnMsg}
              </div>
            )}
            <Grid2><div style={{marginBottom:0}}>
              <label style={{display:'block',fontSize:'11px',fontWeight:600,color:T.muted,marginBottom:'4px',textTransform:'uppercase',letterSpacing:'.05em',fontFamily:FONT}}>Série</label>
              <input
                list="series-suggestions"
                value={form.serie||''} onChange={e=>setForm(p=>({...p,serie:e.target.value}))}
                placeholder="Astérix, Tintin…"
                style={{...inputStyle}} onFocus={fo} onBlur={bl}/>
              <datalist id="series-suggestions">
                {SERIES_POPULAIRES.map(s=><option key={s} value={s}/>)}
              </datalist>
            </div><Inp label="Tome" f="numero" type="number" placeholder="12" min="0" {...p}/></Grid2>
            <Inp label="Titre de l'album" f="titre" placeholder="Le titre complet" {...p}/>
            <Grid2><Sel label="Format" f="format" opts={FORMATS} {...p}/><Inp label="ISBN" f="isbn" placeholder="978-…" {...p}/></Grid2>
            <Grid2><Inp label="Année de parution" f="dateParution" type="number" placeholder="1985" min="1900" max="2030" {...p}/><Sel label="Langue" f="langue" opts={LANGUES} empty="Français" {...p}/></Grid2>
          </div>

          <div style={{marginBottom:'1.5rem'}}><Sec icon="✍️" title="Auteurs"/>
            <Grid2><Inp label="Scénariste" f="scenariste" placeholder="Goscinny…" {...p}/><Inp label="Dessinateur" f="dessinateur" placeholder="Uderzo…" {...p}/></Grid2>
            <Grid2><Inp label="Coloriste" f="coloriste" placeholder="Nom" {...p}/><Inp label="Auteur (one-shot)" f="auteur" placeholder="Prénom Nom" {...p}/></Grid2>
          </div>

          <div style={{marginBottom:'1.5rem'}}><Sec icon="🏢" title="Édition"/>
            <Grid2><Sel label="Éditeur" f="editeur" opts={EDITEURS} {...p}/><Inp label="Collection" f="collection" placeholder="Poisson Pilote…" {...p}/></Grid2>
            <Grid2><Sel label="Genre" f="genre" opts={GENRES} {...p}/><Inp label="Nb de pages" f="nbPages" type="number" placeholder="48" min="1" {...p}/></Grid2>
            <div style={{display:'flex',gap:'16px',flexWrap:'wrap',marginTop:'6px'}}>
              {[{f:'eo',l:'1ère édition (EO)'},{f:'dedicace',l:'Dédicacé'},{f:'numerote',l:'Numéroté'},{f:'lu',l:'Lu ✓'}].map(({f,l})=>(
                <label key={f} style={{display:'flex',alignItems:'center',gap:'7px',cursor:'pointer',fontSize:'13px',fontWeight:600,color:form[f]?T.orange:T.muted}}>
                  <input type="checkbox" checked={!!form[f]} onChange={e=>setForm(p=>({...p,[f]:e.target.checked}))} style={{accentColor:T.orange,width:'16px',height:'16px'}}/>
                  {l}
                </label>
              ))}
            </div>
          </div>

          <div style={{marginBottom:'1.5rem'}}><Sec icon="🔍" title="État physique"/>
            <Field label="État général">
              <div style={{display:'grid',gridTemplateColumns:'repeat(5,minmax(0,1fr))',gap:'6px'}}>
                {ETATS_GENERAUX.map(et=>{
                  const on=form.etatGeneral===et.value;
                  return(
                  <button key={et.value} type="button" onClick={()=>setForm(p=>({...p,etatGeneral:et.value}))}
                    style={{padding:'10px 4px',borderRadius:'10px',cursor:'pointer',textAlign:'center',fontFamily:FONT,border:`1.5px solid ${on?et.color:T.border}`,background:on?et.color+'14':'transparent',transition:'all .15s',display:'flex',flexDirection:'column',alignItems:'center',gap:'4px'}}>
                    <span style={{width:'10px',height:'10px',borderRadius:'50%',background:et.color,display:'block'}}/>
                    <span style={{fontSize:'11px',fontWeight:on?700:500,color:on?et.color:T.muted,lineHeight:1.2}}>{et.label}</span>
                  </button>);
                })}
              </div>
            </Field>

            {/* ── Défauts — accordéon par catégorie ── */}
            <DefautsAccordion
              defauts={form.defauts||[]}
              onToggle={toggleDef}
            />
          </div>

          <div style={{marginBottom:'1.5rem'}}><Sec icon="💰" title="Statut & Valeur"/>
            <div style={{display:'grid',gridTemplateColumns:'repeat(4,minmax(0,1fr))',gap:'6px',marginBottom:'14px'}}>
              {STATUTS.map(s=>{const on=form.statut===s.value;return(
                <button key={s.value} type="button" onClick={()=>setForm(p=>({...p,statut:s.value}))}
                  title={s.desc || s.label}
                  style={{padding:'8px 4px',borderRadius:'10px',cursor:'pointer',textAlign:'center',border:`1.5px solid ${on?s.color:T.border}`,background:on?s.color+'14':'transparent',color:on?s.color:T.muted,fontFamily:FONT,fontSize:'11px',fontWeight:on?700:500,transition:'all .15s',lineHeight:1.25}}>
                  <div style={{fontSize:'16px',marginBottom:'3px'}}>{s.emoji}</div>
                  <div style={{whiteSpace:'normal',wordBreak:'break-word'}}>{s.label}</div>
                </button>);
              })}
            </div>
            {/* Description du statut sélectionné si c'est un statut avec note */}
            {STATUTS.find(s=>s.value===form.statut)?.desc && (
              <div style={{background:'#FFFBEB',border:'1px solid #FDE68A',borderRadius:'8px',padding:'8px 12px',fontSize:'12px',color:'#92400E',marginTop:'-8px',marginBottom:'10px',fontFamily:FONT,lineHeight:1.5}}>
                💡 {STATUTS.find(s=>s.value===form.statut).desc}
              </div>
            )}
            <Grid2>
              <Inp label="Prix d'achat (€)" f="prixAchat" type="number" placeholder="12.50" min="0" step="0.01" {...p}/>
              <Inp label="Prix revente estimé (€)" f="prixVente" type="number" placeholder="8.00" min="0" step="0.01" {...p}/>
            </Grid2>
            <div style={{display:'grid',gridTemplateColumns:'minmax(0,1fr) minmax(0,1fr)',gap:'10px'}}>
              {/* Date d'achat compacte */}
              <div style={{marginBottom:'0',minWidth:0}}>
                <label style={{display:'block',fontSize:'11px',fontWeight:600,color:T.muted,marginBottom:'4px',textTransform:'uppercase',letterSpacing:'.05em',fontFamily:FONT}}>Date d'achat</label>
                <input type="date" value={form.dateAchat||''} onChange={e=>setForm(p=>({...p,dateAchat:e.target.value}))}
                  style={{width:'100%',minWidth:0,padding:'9px 6px',border:`1.5px solid ${T.border}`,borderRadius:'9px',fontFamily:FONT,fontSize:'13px',background:T.surface,color:T.ink,outline:'none',transition:'border-color .15s, box-shadow .15s'}}
                  onFocus={e=>{e.target.style.borderColor=T.orange;e.target.style.boxShadow=`0 0 0 3px rgba(240,78,26,.10)`;}}
                  onBlur={e=>{e.target.style.borderColor=T.border;e.target.style.boxShadow='none';}}/>
              </div>
              {/* Date de lecture */}
              <div style={{marginBottom:'0',minWidth:0}}>
                <label style={{display:'block',fontSize:'11px',fontWeight:600,color:T.muted,marginBottom:'4px',textTransform:'uppercase',letterSpacing:'.05em',fontFamily:FONT}}>Date de lecture</label>
                <input type="date" value={form.dateLecture||''} onChange={e=>setForm(p=>({...p,dateLecture:e.target.value}))}
                  style={{width:'100%',minWidth:0,padding:'9px 6px',border:`1.5px solid ${T.border}`,borderRadius:'9px',fontFamily:FONT,fontSize:'13px',background:T.surface,color:T.ink,outline:'none',transition:'border-color .15s, box-shadow .15s'}}
                  onFocus={e=>{e.target.style.borderColor=T.orange;e.target.style.boxShadow=`0 0 0 3px rgba(240,78,26,.10)`;}}
                  onBlur={e=>{e.target.style.borderColor=T.border;e.target.style.boxShadow='none';}}/>
              </div>
            </div>
            {/* Lieu d'achat — liste déroulante pleine largeur */}
            <div style={{marginBottom:'10px',marginTop:'10px'}}>
              <label style={{display:'block',fontSize:'11px',fontWeight:600,color:T.muted,marginBottom:'4px',textTransform:'uppercase',letterSpacing:'.05em',fontFamily:FONT}}>Lieu d'achat</label>
              <select value={form.lieuAchat||''} onChange={e=>setForm(p=>({...p,lieuAchat:e.target.value}))}
                style={{width:'100%',padding:'9px 12px',border:`1.5px solid ${T.border}`,borderRadius:'9px',fontFamily:FONT,fontSize:'14px',background:T.surface,color:form.lieuAchat?T.ink:T.muted,outline:'none',cursor:'pointer'}}>
                <option value="">— Où tu l'as acheté ?</option>
                {LIEUX_ACHAT.map(l=><option key={l} value={l}>{l}</option>)}
              </select>
            </div>
            <Field label="Ma note">
              <div style={{display:'flex',gap:'4px',alignItems:'center'}}>
                {[1,2,3,4,5].map(n=>(
                  <span key={n} onClick={()=>setForm(p=>({...p,note:p.note===n?0:n}))}
                    style={{fontSize:'26px',cursor:'pointer',color:form.note>=n?T.yellow:'var(--border-md)',transition:'transform .1s',lineHeight:1,display:'inline-block'}}
                    onMouseOver={e=>e.currentTarget.style.transform='scale(1.2)'}
                    onMouseOut={e=>e.currentTarget.style.transform='scale(1)'}>★</span>
                ))}
                {form.note>0&&<span style={{fontSize:'12px',color:T.muted,marginLeft:'4px',fontWeight:600}}>{form.note}/5</span>}
              </div>
            </Field>
          </div>

          <div style={{marginBottom:'1.5rem'}}><Sec icon="📍" title="Localisation"/>
            <Grid2>
              <Inp label="Lieu" f="lieu" placeholder="Salon, chambre…" {...p}/>
              <Inp label="Emplacement précis" f="emplacement" placeholder="Étagère A, boîte 3…" {...p}/>
            </Grid2>
          </div>

          <div style={{marginBottom:'1.5rem'}}><Sec icon="📷" title="Photos"/>
            {!bd?.id&&<div style={{background:'#FFFBEB',border:'1px solid #FDE68A',borderRadius:'9px',padding:'10px 12px',fontSize:'13px',fontWeight:500,color:'#92400E',marginBottom:'10px'}}>💡 Sauvegardez d'abord, puis revenez éditer pour ajouter des photos.</div>}
            <div style={{border:`1.5px dashed ${T.borderMd}`,borderRadius:'10px',padding:'12px',background:T.g1}}>
              {form.photos?.length>0&&(
                <div style={{display:'grid',gridTemplateColumns:'repeat(3,minmax(0,1fr))',gap:'7px',marginBottom:'10px'}}>
                  {form.photos.map((ph,i)=>(
                    <div key={ph.id||i} style={{position:'relative',borderRadius:'8px',overflow:'hidden',aspectRatio:'1',background:T.border}}>
                      <img src={ph.url} alt="" style={{width:'100%',height:'100%',objectFit:'cover',display:'block'}}/>
                      {i===0&&<div style={{position:'absolute',top:'4px',left:'4px',padding:'2px 6px',borderRadius:'5px',background:'rgba(240,78,26,.9)',color:'#fff',fontSize:'9px',fontWeight:700,fontFamily:FONT,letterSpacing:'.03em'}}>COUVERTURE</div>}
                      {bd?.id&&<button onClick={()=>handleDel(ph)} title="Supprimer"
                        style={{position:'absolute',top:'4px',right:'4px',width:'22px',height:'22px',borderRadius:'50%',background:'rgba(0,0,0,.6)',border:'none',cursor:'pointer',color:'#fff',fontSize:'11px',display:'flex',alignItems:'center',justifyContent:'center',fontWeight:800}}>×</button>}
                      {bd?.id&&form.photos.length>1&&(
                        <div style={{position:'absolute',bottom:'4px',left:'4px',right:'4px',display:'flex',justifyContent:'space-between',gap:'4px'}}>
                          <button onClick={()=>movePhoto(i,i-1)} disabled={i===0} title="Déplacer vers la gauche"
                            style={{width:'22px',height:'22px',borderRadius:'6px',background:'rgba(0,0,0,.6)',border:'none',cursor:i===0?'default':'pointer',color:'#fff',fontSize:'12px',display:'flex',alignItems:'center',justifyContent:'center',opacity:i===0?.35:1,fontWeight:800}}>‹</button>
                          {i!==0&&<button onClick={()=>setCover(i)} title="Définir comme couverture"
                            style={{padding:'0 6px',height:'22px',borderRadius:'6px',background:'rgba(0,0,0,.6)',border:'none',cursor:'pointer',color:'#fff',fontSize:'11px',display:'flex',alignItems:'center',justifyContent:'center',fontWeight:700}}>★ 1er</button>}
                          <button onClick={()=>movePhoto(i,i+1)} disabled={i===form.photos.length-1} title="Déplacer vers la droite"
                            style={{width:'22px',height:'22px',borderRadius:'6px',background:'rgba(0,0,0,.6)',border:'none',cursor:i===form.photos.length-1?'default':'pointer',color:'#fff',fontSize:'12px',display:'flex',alignItems:'center',justifyContent:'center',opacity:i===form.photos.length-1?.35:1,fontWeight:800}}>›</button>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
              {uploading&&<div style={{height:'4px',background:T.border,borderRadius:'99px',overflow:'hidden',marginBottom:'10px'}}><div style={{height:'100%',width:`${uploadPct}%`,background:T.orange,borderRadius:'99px',transition:'width .3s'}}/></div>}
              {bd?.id?(
                <>
                  <button onClick={()=>fileRef.current.click()} disabled={uploading}
                    style={{width:'100%',padding:'10px',border:`1.5px dashed ${T.borderMd}`,borderRadius:'8px',background:'transparent',cursor:'pointer',fontSize:'13px',fontFamily:FONT,fontWeight:600,color:T.muted,transition:'all .15s'}}
                    onMouseOver={e=>{e.currentTarget.style.borderColor=T.orange;e.currentTarget.style.color=T.orange;e.currentTarget.style.background='var(--orange-pale)';}}
                    onMouseOut={e=>{e.currentTarget.style.borderColor=T.borderMd;e.currentTarget.style.color=T.muted;e.currentTarget.style.background='transparent';}}>
                    📷 {uploading?`Upload ${uploadPct}%`:'Ajouter des photos'}
                  </button>
                  <input ref={fileRef} type="file" accept="image/*" multiple onChange={handlePhotos} style={{display:'none'}}/>
                </>
              ):<div style={{textAlign:'center',fontSize:'13px',color:T.subtle,fontWeight:500}}>Disponible après la première sauvegarde</div>}
            </div>
          </div>

          <div style={{marginBottom:'1.5rem'}}><Sec icon="💬" title="Notes"/>
            <textarea value={form.notes||''} rows={4} placeholder="Édition collector, souvenir, dédicacé à Paris en 1998…"
              onChange={e=>setForm(p=>({...p,notes:e.target.value}))}
              style={{...inputStyle,resize:'vertical',minHeight:'80px',lineHeight:1.6}} onFocus={fo} onBlur={bl}/>
          </div>
        </div>

        {/* Footer sticky */}
        <div style={{position:'sticky',bottom:0,background:'var(--header-bg)',backdropFilter:'blur(10px)',WebkitBackdropFilter:'blur(10px)',borderTop:`1px solid ${T.border}`,padding:'1rem 1.25rem',display:'flex',gap:'10px',justifyContent:'flex-end'}}>
          <button onClick={onClose} style={{padding:'10px 20px',border:`1.5px solid ${T.border}`,borderRadius:'99px',background:T.surface,fontFamily:FONT,fontSize:'14px',fontWeight:600,color:T.muted,cursor:'pointer',transition:'border-color .15s'}}
            onMouseOver={e=>e.currentTarget.style.borderColor=T.borderMd}
            onMouseOut={e=>e.currentTarget.style.borderColor=T.border}>
            Annuler
          </button>
          <button onClick={handleSave} disabled={saving} style={{
            padding:'10px 24px', border:'none', borderRadius:'99px',
            background:`linear-gradient(135deg,${T.orange},${T.orangeD})`,
            color:'#fff', fontFamily:FONT, fontSize:'14px', fontWeight:700,
            cursor:'pointer', boxShadow:`0 3px 12px rgba(240,78,26,.30)`,
            transition:'transform .15s, box-shadow .15s',
          }}
            onMouseOver={e=>{e.currentTarget.style.transform='translateY(-1px)';e.currentTarget.style.boxShadow=`0 6px 18px rgba(240,78,26,.38)`;}}
            onMouseOut={e=>{e.currentTarget.style.transform='none';e.currentTarget.style.boxShadow=`0 3px 12px rgba(240,78,26,.30)`;}}>
            {saving?'Sauvegarde…':bd?'Enregistrer les modifications':'Ajouter à ma collection'}
          </button>
        </div>
      </div>
    </div>

    {showScanner && (
      <ISBNScanner
        onFound={handleISBNFound}
        onClose={() => setShowScanner(false)}
      />
    )}
  </>
  );
}
